import { useQuery } from '@tanstack/react-query';
import { getLeadById } from '../api/leads';

export function useLead(id: string | null) {
  return useQuery({
    queryKey: ['lead', id],
    queryFn: () => (id ? getLeadById(id) : Promise.resolve(null)),
    enabled: id !== null && id !== '',
  });
}
